(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-festive-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('psf-homepage')) {
  customElements.define('psf-homepage', class extends HTMLElement {
    connectedCallback() {
      if (this.psfInitialized) return;
      this.psfInitialized = true;
      this.psfAbort = new AbortController();
      const options = { signal: this.psfAbort.signal };
      this.psfSlides = Array.from(this.querySelectorAll('[data-psf-slide]'));
      this.psfDots = Array.from(this.querySelectorAll('[data-psf-dot]'));
      this.psfCurrent = 0;
      if (this.psfSlides.length < 2) return;
      this.querySelectorAll('[data-psf-controls], [data-psf-previous], [data-psf-next]').forEach(control => control.hidden = false);
      this.querySelector('[data-psf-previous]').addEventListener('click', () => this.psfShow(this.psfCurrent - 1), options);
      this.querySelector('[data-psf-next]').addEventListener('click', () => this.psfShow(this.psfCurrent + 1), options);
      this.psfDots.forEach((dot, index) => dot.addEventListener('click', () => this.psfShow(index), options));
      document.addEventListener('shopify:block:select', event => {
        const index = this.psfSlides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
        if (index >= 0) this.psfShow(index);
      }, options);
    }
    psfShow(index) {
      this.psfCurrent = (index + this.psfSlides.length) % this.psfSlides.length;
      this.psfSlides.forEach((slide, position) => slide.hidden = position !== this.psfCurrent);
      this.psfDots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.psfCurrent)));
    }
    disconnectedCallback() {
      if (this.psfAbort) this.psfAbort.abort();
      this.psfInitialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-partner-enquiry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psp-enquiry')) {
    customElements.define('psp-enquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        const select = this.querySelector('[data-psp-interest]');
        const message = this.querySelector('[data-psp-message]');
        const guidance = this.querySelector('[data-psp-guidance]');
        const form = this.querySelector('form');
        if (!select || !message || !guidance || !form) return;
        const updateGuidance = () => {
          const help = select.selectedOptions[0]?.dataset.help || '';
          message.placeholder = help;
          guidance.textContent = help;
        };
        const chooseSegment = (segment) => {
          const option = Array.from(select.options).find((item) => item.dataset.segment === segment);
          if (!option) return false;
          select.value = option.value;
          updateGuidance();
          return true;
        };
        select.addEventListener('change', updateGuidance, { signal });
        this.querySelectorAll('[data-psp-segment]').forEach((link) => {
          link.addEventListener('click', (event) => {
            if (!chooseSegment(link.dataset.pspSegment)) return;
            event.preventDefault();
            const target = this.querySelector('.psp-form-card');
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
            select.focus({ preventScroll: true });
          }, { signal });
        });
        form.addEventListener('submit', (event) => {
          if (this.dataset.submissionEnabled !== 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        const requestedSegment = new URLSearchParams(window.location.search).get('interest');
        if (requestedSegment && !select.value && !message.value) chooseSegment(requestedSegment);
        updateGuidance();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
